import { Answer, globalRegions, Identity } from 'altru-types';
import { Api } from '@/store/api';
import { AltruApiResponse } from 'altru-types/@types/generic-response';

export async function register(
  answerId: number,
  payload: string,
  region: globalRegions,
  info?: string,
): Promise<AltruApiResponse<Answer>> {
  const response = await Api.put(`/api/${region}/answers/anonymous_update/${answerId}`, {
    payload,
    info,
  });
  return response.data;
}

export async function me(
  accessToken: string,
  client: string,
  uid: string,
  region: globalRegions,
): Promise<AltruApiResponse<Identity>> {
  const response = await Api.get(`/api/${region}/identities/me`, {
    headers: {
      'access-token': accessToken,
      client,
      uid,
    },
  });
  return response.data;
}
